(function(window, angular) {
  "use strict";

	angular.module('service')
	.factory('taskService', ['baseService', '$http', function(baseService, $http) {
		// inherits
		var extended = angular.copy(baseService);
		// url
		extended.base_url = getFullUrl('/api/task');

		extended.initObj = function(obj) {
			if( obj !== null ) {
				obj = baseService.initObj(obj);

				if( obj.due_at ) {
					obj.due_at = new Date(obj.due_at);
				}
			}
			return obj;
		}

		/**
		 * get log
		 * @param  {object} task task instance
		 * @return {object}              log with ids, etc...
		 */
		extended.searchLogs = function(task, page) {
			if( !task || !task.id ) {
				return;
			}

			var this_instance = this;
			var url = this.base_url + '/' + task.id + '/log';
			if( page ) {
				url += '/?page='.page;
			}

			return $http({
				method: 'GET',
				url: url
			}).then( function(response) {
				var logs = response.data;
				angular.forEach(logs, function(log, idx) {
					this_instance.initObj(log);
				});
				return logs;
			});
		}

		/**
		 * get comments
		 * @param  {object} task task instance
		 * @return {object}              comments with ids, etc...
		 */
		extended.searchComments = function(task, page) {
			if( !task || !task.id ) {
				return;
			}

			var this_instance = this;
			var url = this.base_url + '/' + task.id + '/comment';
			if( page ) {
				url += '/?page='.page;
			}

			return $http({
				method: 'GET',
				url: url
			}).then( function(response) {
				var comments = response.data;
				angular.forEach(comments, function(comment, idx) {
					this_instance.initObj(comment);
				});
				return comments;
			});
		}

		/**
		 * save a obj
		 * @param  object obj to save
		 * @return object     	obj promise
		 */
		extended.saveComment = function(task, comment) {
			if( !task || !task.id || !comment ) {
				return;
			}

			var this_instance = this;
			var url    = this.base_url + '/' + task.id + '/comment';
			var method = 'post';
			if( comment.id ) {
				method = 'put';
				url   += '/' +comment.id + '/';
			}

			return $http({
				method: method,
				url: url,
				data: comment
			}).then( function(response) {
				return this_instance.initObj(angular.extend(comment, response.data));
			});
		}

		/**
		 * delete a obj
		 * @param  integer id obj.id
		 * @return object    http prmise
		 */
		extended.deleteComment = function(task, comment) {
			if( !task || !task.id || !comment || !comment.id ) {
				return;
			}

			var this_instance = this;

			return $http({
				url:this.base_url + '/' + task.id + '/comment/' + comment.id,
				method:'delete',
			}).then(function(response) {
				return this_instance.initObj(response.data) || response;
			});
		}

		/**
		 * ack comments
		 * @param  {object} task task instance
		 * @return {object}              comments with ids, etc...
		 */
		extended.markCommentsAsRead = function(task) {
			return $http({
				method: 'GET',
				url: this.base_url + '/' + task.id + '/mark_comments_as_read'
			}).then( function(response) {
				task.total_unread_comments = 0;
				return task;
			});
		}

		return extended;
	}]);
})(window, window.angular);
